const article = {
  breadcrumb_home: '首页',
  breadcrumb_category: '分类',
  status_ongoing: '连载中',
  status_completed: '已完结',
  author: '作者',
  chapters_count: '共 {{count}} 话',
  views: '阅读',
  rating: '分',
  last_updated: '最近更新',
  tags: '标签',
  chapter_list: '章节目录',
  chapter_sort_asc: '正序',
  chapter_sort_desc: '倒序',
  no_chapters: '暂无章节',
  start_reading: '开始阅读',
  continue_reading: '继续阅读',
  related_comics: '相关推荐',
  description: '作品简介',
  read_first_chapter: '从第1话开始',
};

export default article;